import { fnv1aHex } from '@/utils/hash';

/**
 * Claves semánticas internas. NO son las claves que aparecen en
 * localStorage — se hashean para producir claves opacas.
 */
export type SemanticKey =
  | 'character'
  | 'narrative'
  | 'world'
  | 'meta'
  | 'session_salt';

/** Sal estática para derivar claves. No es secreta. */
const KEY_NAMESPACE = 'tck/v1';

/**
 * Deriva la clave opaca de localStorage para una clave semántica dada.
 * Ejemplo: "character" → "_k_3f92a7c1"
 */
export function claveOpaca(semantic: SemanticKey): string {
  return `_k_${fnv1aHex(`${KEY_NAMESPACE}/${semantic}`)}`;
}

/** Prefijo de todas nuestras claves, útil para barrido completo. */
export const KEY_PREFIX = '_k_';
